module.exports = __webpack_public_path__ + "static/logos-tiles-ws-1a1f4226c7c931d54827e1e7e47ba4d5.svg";